'use strict';
var onetime = require('onetime');
var exitHook = require('exit-hook');

module.exports = onetime(function () {
	exitHook(function () {
		process.stdout.write('\u001b[?25h');
	});
});



//////////////////
// WEBPACK FOOTER
// ./~/restore-cursor/index.js
// module id = 3888
// module chunks = 0